module.exports = __webpack_public_path__ + "fonts/fa-regular-400.2e562d4e.ttf";